import styled from 'styled-components'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const StyledEmail = {
  Root: styled.div`
    width: 100%;
    height: calc(var(--full-height, 100dvh) - var(--header-height));

    &:before {
      position: absolute;
      z-index: -1;
      inset: 0;
      content: '';
      background-color: ${COLORS.GRAY_100};
    }
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    padding-bottom: calc(var(--sab, 0px) + 24px);
    height: 100%;
    overflow-y: auto;
  `,
}
